import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import { AssetMasterModule } from "@/store/modules/asset.module";
import * as _ from "lodash";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
Component.registerHooks(["metaInfo"]);
let AssetSummary = /** @class */ (() => {
    let AssetSummary = class AssetSummary extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Asset Summary Report";
            this.pageIsLoading = false;
            this.showTable = false;
            this.showText = true;
            this.isPageLoading = false;
            this.summaryDate = null;
            this.grantTotal = 0;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Reports",
                },
                {
                    text: "Asset Summary Report",
                    active: true,
                },
            ];
        }
        get assetSummaryReportDetails() {
            return AssetMasterModule.assetSummaryReportDetails;
        }
        get sortedSummaryReport() {
            return _.sortBy(AssetMasterModule.assetSummaryReportDetails, (item) => item.assetCategoryName);
        }
        GenerateAssetSummaryReportAsExcel() {
            this.isPageLoading = true;
            this.validate("validateObserver").then((res) => {
                if (res) {
                    AssetMasterModule.GetAssetsSummaryReportAsExcel(this.dateFormattedString(this.summaryDate)).then((res) => {
                        if (res) {
                            const blob = new Blob([res], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            document.body.appendChild(link);
                            link.download = `AssetSummaryReport.xlsx`;
                            link.click();
                            this.isPageLoading = false;
                        }
                    });
                }
            });
        }
        getAssetSummaryDetails() {
            this.validate("validateObserver").then((res) => {
                if (res) {
                    this.pageIsLoading = true;
                    this.showText = false;
                    AssetMasterModule.GetAssetsSummaryReport(this.dateFormattedString(this.summaryDate)).then((res) => {
                        if (res) {
                            this.showTable = true;
                            this.pageIsLoading = false;
                        }
                    });
                }
            });
        }
        created() {
            this.pageIsLoading = false;
        }
    };
    AssetSummary = __decorate([
        Component({
            name: "AssetSummary",
            components: {
                Loader,
                Layout,
                PageHeader,
                SectionLoader,
                simplebar,
            },
        })
    ], AssetSummary);
    return AssetSummary;
})();
export default AssetSummary;
